import * as React from 'react';

import { CartServiceProps } from '../../types';
import { ServiceSummary } from '../../../features/service-summary';

const BusinessLounge: React.FC<CartServiceProps> = ({ onServiceDelete }) => {
	return (
		<ServiceSummary serviceType="BusinessLounge" onDelete={onServiceDelete}>
			{content => <>{content}</>}
		</ServiceSummary>
	);
};

export default BusinessLounge;
